import { render, staticRenderFns } from "./praise-card.vue?vue&type=template&id=144b46ae&scoped=true&"
import script from "./praise-card.vue?vue&type=script&lang=js&"
export * from "./praise-card.vue?vue&type=script&lang=js&"
import style0 from "./praise-card.vue?vue&type=style&index=0&id=144b46ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144b46ae",
  null
  
)

export default component.exports